/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomDefinition extends models.AppSecopsSbomDefinitionBase {
    getFixupPrototypeFunction() { return AppSecopsSbomDefinition.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomDefinition>): AppSecopsSbomDefinition {
        let obj = Object.assign(new AppSecopsSbomDefinition(), model);
        AppSecopsSbomDefinition.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomDefinition>): AppSecopsSbomDefinition {
        if (!model) return null;
        return AppSecopsSbomDefinition.newInstance(<AppSecopsSbomDefinition> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomDefinition) {
        if (!obj) return;

        models.AppSecopsSbomDefinition.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomDefinition): boolean {
        if (models.AppSecopsSbomDefinitionBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsSbomDefinition.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
        if (this.resource_mapping_details) {
            models.AppSecopsSbomResourceMappingDetails.fixupPrototype(this.resource_mapping_details);
        }
    }

    /**
     * Unique ID of the Sbom
     */
    sbom_definition_id: string;

    /**
     * Release version ID of SBOM
     */
    release_version_id: string;

    /**
     * SBOM related project ID
     */
    appsecops_project_id: string;

    /**
     * SBOM definition created date
     */
    created_at: Date;

    /**
     * Name of the user who created the SBOM definition
     */
    created_by: string;

    /**
     * Name of the user who recently updated the SBOM definition
     */
    updated_by: string;

    /**
     * SBOM definition updated date
     */
    updated_at: Date;

    /**
     * Details of resources mapped to SBOM.
     */
    resource_mapping_details: models.AppSecopsSbomResourceMappingDetails;

}
